import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/useUserServicePostHook";
import Card from "../Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useForm } from "react-hook-form";
import UserIcon from "../../assets/profile.png";
import Button from "../Reusable/Button";
import Modal from "../Reusable/Modal";
import TextField from "../Reusable/TextField";
import ChangePassword from "./ChangePassword";
import UpdateBranch from "./UpdateBranch";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { editRiderVaidationForm } from "../../utils/validationSchemas";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import LocalCombobox from "../Reusable/LocalCombobox";
const EditRider = (props: any) => {
  const { profile, handleEdit } = props;
  const [openChangePasswordPopup, setOpenChangePasswordPopup] = useState(false);
  const [openUpdatebranchPopup, setOpenUpdatebranchPopup] = useState(false);

  const TypeData = [
    {
      name: "flat",
      id: "flat",
    },
    {
      name: "percentage",
      id: "percentage",
    },
  ];

  const { mutateAsync, isPostLoading: isUserUpdateLoading } = usePostHook({
    queryKey: ["rider"],
    navigateURL: "/",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.USER}${profile?.user?.id}/update-profile/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
    control,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        full_name: profile?.user?.full_name,
        email: profile?.user?.email,
        username: profile?.user?.username,
        mobile_number: profile?.user?.mobile_number,
        commission: profile?.commission,
        commission_type: profile?.commission_type,
      };
    },
    resolver: yupResolver(editRiderVaidationForm),
  });

  return (
    <>
      <Card>
        <div className={tw`m-2`}>
          <div className={tw`flex flex-row  items-center justify-between`}>
            <div
              className={tw`flex flex-row gap-x-2 items-center justify-center`}
            >
              <img
                src={UserIcon}
                alt="User Icon"
                className={tw`cursor-pointer h-16 w-16`}
              />
              <div>
                <p> {profile?.name}</p>
                <p>
                  <span className={tw`block`}>Rider</span>
                </p>
                <p className={tw`block cursor-pointer`}>
                  {profile?.branch?.name?.length
                    ? profile?.branch?.name
                    : "N/A"}
                </p>
              </div>
            </div>

            <div className={tw`w-[150px] mt-6`}>
              <Button
                label={"Change Password"}
                onClick={() =>
                  setOpenChangePasswordPopup(!openChangePasswordPopup)
                }
              />
            </div>
          </div>
          <form
            className={tw`mt-10`}
            onSubmit={handleSubmit((data) => {
              handleUpdateProfile(data, setError), handleEdit(data, setError);
            })}
          >
            <div>Personal Information</div>
            <div className={tw`grid grid-cols-2 gap-x-6`}>
              <TextField
                label={"Name"}
                register={register("full_name")}
                errors={errors?.full_name}
              />
              <TextField
                label={"Username"}
                register={register("username")}
                errors={errors?.username}
              />
              <TextField
                label={"Email"}
                register={register("email")}
                errors={errors?.email}
              />
              <PhoneNumberField
                control={control}
                label={"Phone Number"}
                name={"mobile_number"}
                errors={errors?.mobile_number}
              />
              <LocalCombobox
                label={"Commission Type"}
                placeholder={"Search type"}
                props={{}}
                control={control}
                errors={errors?.commission_type}
                name={"commission_type"}
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                data={TypeData}
              />
              <TextField
                label={"Commission rate"}
                register={register("commission")}
                errors={errors?.commission}
              />
            </div>
            <div className={tw`w-full flex justify-end`}>
              <div className={tw`w-32`}>
                <Button label={"Update"} isLoading={isUserUpdateLoading} />
              </div>
            </div>
          </form>
        </div>
      </Card>
      <Modal
        isOpen={openChangePasswordPopup}
        setIsOpen={setOpenChangePasswordPopup}
        title={"Change Password"}
        children={
          <>
            <ChangePassword
              profile={profile}
              setOpenChangePasswordPopup={setOpenChangePasswordPopup}
            />
          </>
        }
      />
      <Modal
        isOpen={openUpdatebranchPopup}
        setIsOpen={setOpenUpdatebranchPopup}
        title={"Update Branch"}
        children={
          <>
            <UpdateBranch
              profile={profile}
              setOpenUpdatebranchPopup={setOpenUpdatebranchPopup}
            />
          </>
        }
      />
    </>
  );
};

export default EditRider;
